import { createReducer, on } from "@ngrx/store";
import {
  IShowHideCatalogos,
  InnitShowHideCatalogos,
} from "../../interfaces/admonCatalogos";
import { resetHideCatalogo, showHideCatalogo } from "./actions";

export const initialState: IShowHideCatalogos = InnitShowHideCatalogos;

export const admonCatalogosReducer = createReducer(
  initialState,
  on(
    showHideCatalogo,
    (state, { tipoCatalogo, mostrarEditar, mostrarNuevo, guardando }) => {
      const resetState: IShowHideCatalogos = { ...initialState };
      if (tipoCatalogo in resetState) {
        resetState[tipoCatalogo as keyof IShowHideCatalogos] = {
          mostrarEditar,
          mostrarNuevo,
          guardando,
        };
      }
      return resetState;
    }
  ),
  on(resetHideCatalogo, () => {
    return initialState;
  })
);
